"use client";

import { useMemo } from "react";

import { useTranslations } from "@/services/i18n";

import { Hero } from "../../_components/hero/hero";

export function HeroSection() {
  const t = useTranslations("pages.consultations.hero");

  const items = useMemo(
    () => ({
      title: {
        text: t("title"),
        icon: "ph:couch",
      },
      heading: t.rich("heading"),
      description: t("description"),
      buttons: [{ label: t("buttons.1.label"), href: "https://upacjenta.pl/konsultacje-online/wynikow" }],
      image: [
        {
          src: "https://assets-cdn.upacjenta.pl/9eb58365-94da-4a80-b31c-d69f0ba8113c.png",
          alt: "",
          width: 632,
          height: 632,
        },
      ],
    }),
    [t],
  );

  return <Hero classes={{ heading: { heading: "md:text-left" } }} {...items} />;
}
